module.exports = __webpack_public_path__ + "static/media/batman2.84e36eeb.jpg";